<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="'Édition du parking'"
      :subtitle="`${pkg ? pkg.ref : ''}`">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <parking-form
          @submit="updateParking"
          :source-loading="loading"
          :source-lot-program="lotProgram"></parking-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import LotMixin from '@/components/lots/LotMixin'

export default {
  name: 'ParkingEdit',
  components: {
    ParkingForm: () => import('./ParkingForm')
  },
  mixins: [LotMixin]
}
</script>
